import { configureStore } from '@reduxjs/toolkit'
import projectSlice from './project/projectSlice';
import orderReducer from './order/orderSlice';
import { orderMiddleware, userProfileMiddleware } from '../middlewares';
import { orderChecklistMiddleware } from '../middlewares/orderChecklist';
import { orderResetMiddleware } from '../middlewares/orderReset';

export default function store() {
  return configureStore({
    reducer: {
      project: projectSlice,
      order: orderReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
      userProfileMiddleware,
      orderMiddleware,
      orderChecklistMiddleware,
      orderResetMiddleware,
    ),
    devTools: process.env.NODE_ENV !== 'production'
  });
}
